import { MessageCircle } from "lucide-react";
import { Button } from "@/shared/components/ui/button";
import { useDrPhillipPanel } from "../context/DrPhillipContext";
import { useDrPhillipPreference } from "@/shared/hooks";

export function DrPhillipTrigger() {
  const { toggle } = useDrPhillipPanel();
  const { isEnabled, isHidden } = useDrPhillipPreference();

  if (!isEnabled || isHidden) return null;

  return (
    <Button
      variant="ghost"
      size="icon"
      className="h-9 w-9"
      onClick={toggle}
      aria-label="Chat with Dr. Phillip"
      title="Chat with Dr. Phillip"
    >
      <MessageCircle className="h-5 w-5" />
    </Button>
  );
}
